import { useQuery } from "@tanstack/react-query";

import api from "../api";
import { paranoidModeQueryKey } from "../queryKeys";
import { allComponentsByLevel } from "../@types";

const useParanoidMode = () => {
  const { data, isSuccess } = useQuery({
    queryKey: paranoidModeQueryKey,
    queryFn: () => api.getParanoidModeConfig(),
    select: ({ data: paranoidModeConfig }) => {
      const enabledComponents = {
        ...allComponentsByLevel,
        [paranoidModeConfig.level]: paranoidModeConfig.included
      };
      return { paranoidModeConfig, enabledComponents };
    }
  });

  return {
    paranoidModeConfig: data?.paranoidModeConfig,
    enabledComponents: data?.enabledComponents,
    isSuccess
  };
};

export default useParanoidMode;
